/** Web-only services the shell needs beyond the shared view models (provided by App from the container). */
import type { NotificationsViewModel } from "@bundle/core";
import { createContext, useContext } from "react";
import type { AnalyticsService } from "../platform/analytics.ts";

export type PlatformServices = {
  analytics: AnalyticsService;
  notifications: NotificationsViewModel;
  /** Unregisters this device's push token, then signs out. */
  signOut: () => Promise<void>;
};

export const PlatformContext = createContext<PlatformServices | null>(null);

export function usePlatform(): PlatformServices {
  const value = useContext(PlatformContext);
  if (value === null) throw new Error("PlatformContext provider missing");
  return value;
}
